import { useEffect, useRef } from "react"
import ReactDOM from "react-dom/client"

export default function Frame({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const ref = useRef<HTMLIFrameElement | null>(null)
  const root = useRef<ReactDOM.Root | null>(null)

  useEffect(() => {
    const renderFrameContents = () => {
      if (
        ref.current &&
        ref.current.contentDocument?.readyState === "complete"
      ) {
        if (!root.current) {
          const div = ref.current.contentDocument.createElement("div")
          ref.current.contentDocument.body.appendChild(div)
          root.current = ReactDOM.createRoot(div)
        }
        root.current.render(children)
      } else {
        setTimeout(renderFrameContents, 0)
      }
    }
    renderFrameContents()
  }, [children])

  return <iframe ref={ref} className={className} />
}
